import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import * as React from 'react';
import { useMemo } from 'react';
import useDraggableControl, { draggableControlDefaultProps, draggableControlPropTypes } from './draggable-control';
import { crispPixel } from '../utils/crisp-pixel';
var defaultProps = Object.assign({}, draggableControlDefaultProps, {
  className: ''
});
function getPosition(_ref) {
  var props = _ref.props,
    state = _ref.state,
    context = _ref.context;
  var longitude = props.longitude,
    latitude = props.latitude,
    offsetLeft = props.offsetLeft,
    offsetTop = props.offsetTop;
  var dragPos = state.dragPos,
    dragOffset = state.dragOffset;
  if (dragPos && dragOffset) {
    return [dragPos[0] + dragOffset[0], dragPos[1] + dragOffset[1]];
  }
  var _context$viewport$pro = context.viewport.project([longitude, latitude]),
    _context$viewport$pro2 = _slicedToArray(_context$viewport$pro, 2),
    x = _context$viewport$pro2[0],
    y = _context$viewport$pro2[1];
  x += offsetLeft;
  y += offsetTop;
  return [x, y];
}
function Marker(props) {
  var thisRef = useDraggableControl(props);
  var state = thisRef.state,
    containerRef = thisRef.containerRef;
  var children = props.children,
    className = props.className,
    draggable = props.draggable,
    style = props.style;
  var dragPos = state.dragPos;
  var _getPosition = getPosition(thisRef),
    _getPosition2 = _slicedToArray(_getPosition, 2),
    x = _getPosition2[0],
    y = _getPosition2[1];
  var transform = "translate(".concat(crispPixel(x), "px, ").concat(crispPixel(y), "px)");
  var cursor = draggable ? dragPos ? 'grabbing' : 'grab' : 'auto';
  var control = useMemo(function () {
    var containerStyle = _objectSpread({
      position: 'absolute',
      left: 0,
      top: 0,
      transform: transform,
      cursor: cursor
    }, style);
    return React.createElement("div", {
      className: "mapboxgl-marker ".concat(className),
      ref: thisRef.containerRef,
      style: containerStyle
    }, children);
  }, [children, className]);
  var container = containerRef.current;
  if (container) {
    container.style.transform = transform;
    container.style.cursor = cursor;
  }
  return control;
}
Marker.defaultProps = defaultProps;
export default React.memo(Marker);